/* Persistance de la complétion des tutos côté back.

   Quand un tuto se termine (le moteur émet `tour:completed` avec l'id du tuto),
   on retrouve le chapitre d'onboarding correspondant et on le marque `completed`
   en DB via POST …/companyOnboardingChapter/{id}/complete.

   Le pont se fait par `condition_key` :
     tuto front → condition_key (TOUR_TO_CONDITION_KEY)
                → chapitre de getStartOnboarding (déjà chargé dans le store)
                → son `id` (UUID) → endpoint complete.

   Chargé une fois au démarrage (import dans main.ts) → indépendant de la page
   sur laquelle le tuto se termine (dashboard, /invoices, /categories…). */

import AppBus from '@/bus/app-bus';
import store from '@/store';
import {TOUR_TO_CONDITION_KEY, chaptersToChecklist} from './catalog';
import {
  pushOnboardingToEngine,
  snoozeOnboardingRecap,
} from './onboarding-recap';

// « Plus tard » (recap) → on reporte l'auto-ouverture, sans toucher au dismiss.
AppBus.$on('tour:snooze', () => snoozeOnboardingRecap());

// « Désactiver les guides automatiques » (bouton intro) → dismissed=true en back
// (source de vérité unique, remplace l'opt-out localStorage).
AppBus.$on('tour:optout', async () => {
  try {
    await store.dispatch('onboarding/actionSetOnboardingDismissed', {
      dismissed: true,
    });
  } catch (err) {
    console.warn('[onboarding] dismiss non persisté', err);
  }
});

/* Parcours ENTIER bouclé (socle + priorités « Pour aller plus loin ») → on pose
   `dismissed` en back : plus rien à faire, on n'auto-ouvre plus (c'est désormais
   le SEUL droit d'affichage, cf. shouldShowOnboardingRecap). Tant qu'une priorité
   reste, on NE dismisse PAS : le recap continue de la surfacer. L'écran de fin
   déjà affiché n'est pas fermé : l'utilisateur voit sa célébration + « Pour aller
   plus loin », et c'est au rechargement suivant que plus rien ne s'ouvrira.
   À SUPPRIMER dès que le back pose le flag lui-même à la complétion. */
async function dismissIfJourneyComplete(): Promise<void> {
  const {chapters = [], guideMeta} = (store.state as any).onboarding || {};
  if (guideMeta?.dismissed) return; // déjà posé (ou refusé par l'utilisateur)
  const journey = chaptersToChecklist(chapters);
  if (!journey.length || !journey.every((c) => c.completed)) return;
  try {
    await store.dispatch('onboarding/actionSetOnboardingDismissed', {
      dismissed: true,
    });
  } catch (err) {
    console.warn('[onboarding] fin de parcours non persistée', err);
  }
}

AppBus.$on('tour:completed', async (tourId: string) => {
  const key = TOUR_TO_CONDITION_KEY[tourId];
  if (!key) return; // tuto sans chapitre back (rien à persister)
  try {
    // L'état onboarding est normalement déjà chargé (Dashboard.loadOnboardingChecklist).
    // Sinon on le récupère pour retrouver l'UUID du chapitre.
    let chapters = store.state.onboarding?.chapters || [];
    if (!chapters.length) {
      await store.dispatch('onboarding/actionGetStartOnboarding');
      chapters = store.state.onboarding?.chapters || [];
    }
    const chapter = chapters.find((c: any) => c.condition_key === key);
    if (!chapter?.id) return; // le chapitre n'est pas dans l'onboarding de la company
    await store.dispatch(
      'onboarding/actionCompleteCompanyOnboardingChapter',
      chapter.id,
    );
    // Recharge l'état pour que la checklist « Prise en main » reflète la coche…
    await store.dispatch('onboarding/actionGetStartOnboarding');
    // …et re-pousse les steps au moteur : la coche DB est à jour et, si le socle
    // vient d'être bouclé, les priorités (scénario, taux de change…) se révèlent.
    pushOnboardingToEngine(store.state.onboarding?.chapters || []);
    // Re-render l'écran de fin s'il est affiché → l'item qu'on vient de terminer
    // passe coché (et « Pour aller plus loin » apparaît si le socle est bouclé).
    (window as any).FygrTour?.refreshEnd?.();
    await dismissIfJourneyComplete();
  } catch (err) {
    // Non bloquant : la fin du tuto ne doit jamais casser à cause de ça.
    console.warn('[onboarding] complete non persisté', err);
  }
});

export {};
